import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';

import { environment } from "@environments/environment";

// Interfaces
import { ResponseDataBase } from '@interfaces/index.interface';

@Injectable()
export class ResourceService {
  justOnePayor: EventEmitter<any> = new EventEmitter();
  cc = window as any;
  environmentName = environment.envName;
  backURL = environment.BACKURL;
  loading: boolean;
  selectedFreeslot: any;
  hospitals = [];
  payors = [];
  departments = [];
  treatments = [];
  visitTypes = [];
  timeframes = [
    { id: 1, name: "MORNING" },
    { id: 2, name: "AFTERNOON" }
  ];
  doctors = [];
  languages = [];
  sexs = [];
  countries = [];
  states = [];
  roles = [];
  schedules = [];
  buildingUnits = [];
  configurationsParams = [];
  doctypes = [];
  defaultLanguage = environment.DEFAULTLANGUAGE;
  isMobile: boolean = false;
  alert: string;
  language;
  confirmDays;
  isAndroidApp;

  constructor(public http: HttpClient,
    public translate: TranslateService) {

    this.loading = true;

    this.language = this.defaultLanguage;

    this.getResource('hospitals')
      .subscribe(data => {
        let response = data as ResponseDataBase;
        this.hospitals = response.result;
        if (this.hospitals.length == 1) {
          let params = {
            hospitalId: this.hospitals[0].id,
          };
          this.getResourceWithParams('departments', params)
            .subscribe(data => {
              let response = data as ResponseDataBase;
              this.departments = response.result;
              this.loading = false;
            });
        }
        this.loading = false;
      });

    this.getResource('languages')
      .subscribe(data => {
        let response = data as ResponseDataBase;
        this.languages = response.result;
        this.loading = false;
      });


    this.getResource('payors')
      .subscribe(data => {
        let response = data as ResponseDataBase;
        this.payors = response.result;
        // this.payors = [{ "id": "SOLO_UN_PAGADOR", "name": "SOLO_UN_PAGADOR_HARDCODEADO", "warnMessage": "", "webActive": true, "lastUsed": false, "selfPayer": true }]
        if (this.payors.length == 1) {
          this.justOnePayor.emit(this.payors);
        }
        this.payors.sort((a, b) => a.name > b.name ? 1 : -1);
        this.loading = false;

      });

    this.getResource('sexs')
      .subscribe(data => {
        let response = data as ResponseDataBase;
        this.sexs = response.result;
        this.loading = false;
      });

    this.getResource('countries')
      .subscribe(data => {
        let response = data as ResponseDataBase;
        this.countries = response.result;
        this.loading = false;
      });

    if (!environment.RESOURCES_ON_DATABASE) {
      this.getResource('visitTypes')
        .subscribe(data => {
          let response = data as ResponseDataBase;
          // Añadimos la videoconsulta mientras no nos llegue de SAP
          // response.result[2].id = 3;
          // response.result[2].name = 'Video call - F';

          this.visitTypes = response.result;
          this.loading = false;
        });
    }

    this.getResource('doctypes')
      .subscribe(data => {
        let response = data as ResponseDataBase;
        this.doctypes = response.result;
        this.loading = false;
      });

    if (navigator.userAgent.match(/Android/i)
      || navigator.userAgent.match(/webOS/i)
      || navigator.userAgent.match(/iPhone/i)
      || navigator.userAgent.match(/iPad/i)
      || navigator.userAgent.match(/iPod/i)
      || navigator.userAgent.match(/BlackBerry/i)
      || navigator.userAgent.match(/Windows Phone/i)
    ) {
      this.isMobile = true;
    }

    if (document.referrer.includes('android-app')
    ) {
      this.isAndroidApp = true;
    }

    if (environment.OPTIONAL_FIELDS_FOR_REGISTER.STATE) {
      this.getResource('states')
        .subscribe(data => {
          let response = data as ResponseDataBase;
          this.states = response.result;
          this.loading = false;
        });
    }

  }

  getResourceWithParams(resource, params) {
    let url = this.backURL + 'rest/resource/' + resource;
    return this.http.get(url, { params: params })
  }

  getResource(id) {
    this.loading = true;
    let url = this.backURL + 'rest/resource/' + id;
    this.http.get(url).subscribe(data => { }, err => {
      if (err.status == 401) {
        this.alert = "INVALID_TOKEN";
      }
    });
    return this.http.get(url);
  }

  updateResource(typeResource: string, resource: any) {
  }

  /*   sendMail(content) {
    let url = this.backURL + 'rest/user/resetpass';
    return this.http.post(url, content);
    } */

  sendMail(params) {
    this.loading = true;
    let url = this.backURL + 'rest/resource/sendmail';
    return this.http.post(url, params)
  }

  applyforpin(params) {
    this.loading = true;
    let url = this.backURL + 'rest/resource/applyforpin';
    return this.http.post(url, params)
  }

  clearCache() {
    delete this.alert;
    this.loading = true;
    let url = this.backURL + 'rest/resource/clearCache';
    return this.http.get(url);
  }

  convertToTableSlots(freeslots) {
    var convertSlots = [];
    freeslots.forEach(function (value, key) {
      if (value.doctor == undefined) {
        value.doctor = {
          name: value.department.name
        }
      }
      if (convertSlots[value.date] != undefined) {
        if (convertSlots[value.date][value.doctor] != undefined) {
          if (convertSlots[value.date][value.doctor.id][value.hour] != undefined) {
            // Añadimos la hora
            convertSlots[value.date][value.doctor.id][value.hour].push(value)
          } else {
            // Creamos el index y añadimos la hora
            convertSlots[value.date][value.doctor.id][value.hour] = [value];
          }
        } else {
          // Creamos el index de doctor, creamos el array de horas, creamos el index de hora y añadimos todo
          if (value.doctor) {
            if (!convertSlots[value.date][value.doctor.id]) {
              convertSlots[value.date][value.doctor.id] = [];
              convertSlots[value.date][value.doctor.id]['name'] = value.doctor.name;
            }
            convertSlots[value.date][value.doctor.id][value.hour] = [value];
          }
        }
      } else {
        // Creamos el index de doctor, creamos el array de horas, creamos el index de hora y añadimos todo
        convertSlots[value.date] = [];
        if (convertSlots[value.date][value.doctor] != undefined) {
          if (convertSlots[value.date][value.doctor.id][value.hour] != undefined) {
            // Añadimos la hora
            convertSlots[value.date][value.doctor.id][value.hour].push(value)
          } else {
            // Creamos el index y añadimos la hora
            convertSlots[value.date][value.doctor.id][value.hour] = [value];
          }
        } else {
          if (value.doctor) {
            if (!convertSlots[value.date][value.doctor.id]) {
              convertSlots[value.date][value.doctor.id] = [];
              convertSlots[value.date][value.doctor.id]['name'] = value.doctor.name;
            }
            convertSlots[value.date][value.doctor.id][value.hour] = [value];
          }
        }
      }
    });
    return convertSlots;
  }

  checkDni(dni) {
    let number
    let leter
    var letra
    var regular_expresion_dni

    regular_expresion_dni = /^\d{8}[a-zA-Z]$/;

    if (regular_expresion_dni.test(dni) == true) {
      number = dni.substr(0, dni.length - 1);
      leter = dni.substr(dni.length - 1, 1);
      number = number % 23;
      letra = 'TRWAGMYFPDXBNJZSQVHLCKET';
      letra = letra.substring(number, number + 1);
      if (letra != leter.toUpperCase()) {
        // alert('Dni erroneo, la letra del NIF no se corresponde');
        return false;
      } else {
        return true;
      }
    } else {
      // alert('Dni erroneo, formato no válido');
      return false;
    }
  }

  getTextFromFile(file) {
    return this.http.get(file, { responseType: 'text' as 'json' });
  }

  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  validatePassword(password) {
    if (this.environmentName == 'dev' || this.environmentName == 'prod') {
      return true;
    } else {
      // This match 6 or more any chars but newline:
      var re = /^.{6,}$/;
      return re.test(String(password));
    }
  }

  validateTypetPasswordwithUserName(password, username) {

    if (password.includes(username)) {
      // Mira si la pass contiene el username, si lo tiene damos error,
      return false;
    } else {
      // Esta expresión regular pide que tenga más de 8 caracteres, al menos una mayúscula, una minúscula y un caracter especial
      // y no tres números consecutivos
      var re = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s)(?:(?!012|123|234|345|456|567|678|789).).{7,}$/;
      return re.test(String(password));
    }
  }

  validateTypetPassword(password) {
    // Valida si la pass solo tiene letras y/o números y que tenga entre 8 y 20 caracteres
    var re = /^[A-Za-z0-9]\w{7,19}$/;
    return re.test(String(password));
  }

  searchLogingAttemps(params) {
    this.loading = true;
    let url = this.backURL + 'rest/resource/getloginattemps';
    return this.http.get(url, { params: params });
  }

  searchDatabaseLogs(params) {
    this.loading = true;
    let url = this.backURL + 'rest/resource/getdatabaselogs';
    return this.http.get(url, { params: params });
  }

  formatDate(date) {
    let formatedDate;
    if (typeof (date) == 'string' || !date.day) {
      formatedDate = moment(date, "DD-MM-YYYY").format('YYYY-MM-DD');
    } else {
      // date.month--;
      // Le añadimos el 0 para que nos devuelva siempre la fecha en formato YYYY-MM-DD
      date.month = "0" + date.month;
      date.day = "0" + date.day;
      formatedDate = date.year + '-' + date.month.slice(-2) + '-' + date.day.slice(-2);
    }
    return formatedDate;
  }

  getBrowserInfo() {
    var ua = navigator.userAgent, tem,
      M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return 'IE ' + (tem[1] || '');
    }
    if (M[1] === 'Chrome') {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M.join(' ');
  };

  manageErrorMessage(errorMessage) {
    if (errorMessage && errorMessage.includes("{{")) {
      console.log(2, errorMessage);
      let keys = errorMessage.split(/[{}]/).filter(function (el) {
        return el.length > 0;
      });
      for (let i = 0; i < keys.length; i + 2) {
        this.translate.get(keys[i]).subscribe(
          translation => {
            if (i == 0) {
              this.alert = translation;
            } else {
              this.alert = this.alert + ' ' + translation;
            }
            if (keys[i + 1]) {
              this.alert = this.alert + ' ' + keys[i + 1];
            }
          });
        i = i + 2;
      }
    } else {
      this.alert = errorMessage;
    }
    this.loading = false;
  }

  isFileImage(file) {
    const acceptedImageTypes = ['image/gif', 'image/jpeg', 'image/png'];
    return file && acceptedImageTypes.includes(file['type'])
  }

  cloneObject(object) {
    return JSON.parse(JSON.stringify(object));
  }

}
